/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A per-project map a dimension reads through at query time: a reported value with an entry shows as its target, the rest show as reported.
 */
export type AnalyticsLookup = {
  /**
   * What the map is and where it is set
   */
  description: string;
  name: string;
};

/** @internal */
export const AnalyticsLookup$inboundSchema: z.ZodMiniType<
  AnalyticsLookup,
  unknown
> = z.object({
  description: z.string(),
  name: z.string(),
});

export function analyticsLookupFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsLookup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsLookup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsLookup' from JSON`,
  );
}
